import {pushga} from '@stencil/ga-utils';

const fetchVoyagerAutoSuggestions = async (
  {inputValue, isByPassBlankInput = false},
  {signal},
  getUrl,
) => {
  const fetchVoyagerUrlForInput = getUrl(inputValue);

  if ((!inputValue && !isByPassBlankInput) || !fetchVoyagerUrlForInput) {
    return [];
  }

  const res = await fetch(fetchVoyagerUrlForInput, {signal});
  if (!res.ok) throw new Error(res.statusText);
  const ret = await res.json();

  if (
    (ret && Array.isArray(ret) && !ret?.length) ||
    (ret?.data && ret?.data?.r && !ret?.data?.r?.length)
  ) {
    pushga({
      eventAction: 'Autosuggest_NoResults',
      eventLabel: `${inputValue}_Noresults`,
    });
  }
  return ret;
};

export default fetchVoyagerAutoSuggestions;
